import { DateTime } from 'luxon';
import { NextPageContext } from 'next';
import { apiCall } from '@/utils/api';
import { validateQueryDate } from '@/legacy/utils/dates';
import { buildQueryParamString } from '@/legacy/utils/url';

export const getCoverageReports = async (
  username = '',
  date = '',
  limit = 0,
  skip = 0,
  req?: NextPageContext['req'],
) => {
  try {
    let from = '';
    let to = '';
    if (validateQueryDate(date)) {
      const isoDate = DateTime.fromISO(date, { zone: 'utc' });
      from = isoDate.startOf('day').toISO() as string;
      if (isoDate.hour === 0 && isoDate.minute === 0 && isoDate.second === 0) {
        to = isoDate.endOf('day').toISO() as string;
      } else {
        to = isoDate.toISO() as string;
      }
    }
    const params = buildQueryParamString({
      ...(from && { from }),
      ...(to && { to }),
      ...(limit && { limit: limit.toString() }),
      ...(skip && { skip: skip.toString() }),
    });
    const URL = `${process.env.NEXT_PUBLIC_API}/coverage/user/${username}${params}`;
    const response = await apiCall(URL, {
      method: 'GET',
      headers: {
        cookie: req?.headers.cookie,
      },
    });
    return response;
  } catch (error: any) {
    console.log(error);
    return { error };
  }
};

export const ignoreCoverage = async (
  id: string,
  isSequenceId: boolean = false,
) => {
  try {
    if (!id) throw new Error('Missing id');
    const URL = `${process.env.NEXT_PUBLIC_API}/coverage/ignore/${id}`;
    const response = await apiCall(
      URL,
      {
        method: 'POST',
      },
      {
        isSequenceId,
      },
    );
    return response;
  } catch (error: any) {
    console.log(error);
    return { error };
  }
};
